import { useCallback, useMemo, useState } from 'react';

// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import clsx from 'clsx';
import { useMenuList } from 'layouts/components/Menu/hooks/useMenuList';
import { MenuProps, useSidebarState } from 'react-admin';

import { MenuCollapseItem } from './components/MenuCollapseItem';
import { MenuItemLink } from './components/MenuItemLink/MenuItemLink';
import { MenuItemLinkWithCounter } from './components/MenuItemLinkWithCounter/MenuItemLinkWithCounter';
import { MenuSubMenuPanel } from './components/MenuSubMenuPanel/MenuSubMenuPanel';
import { MenuToggleButton } from './components/MenuToggleButton/MenuToggleButton';
import { MultiLevelMenuItem } from './constants/menuList';
import {
  MenuBaseStyled,
  StyledBackgroundBox,
  StyledMenuItemsBox,
  StyledMenuToggleButtonBox,
} from './Menu.styled';

export const Menu: React.FC<MenuProps> = ({ className, ...rest }) => {
  const [openSidebar, setOpenSidebar] = useSidebarState();
  const { menuList } = useMenuList();

  const [currentResourceMenuItem, setCurrentResourceMenuItem] = useState<string | null>(null);

  const selectedResourceMenuItem = useMemo(
    () => menuList.find((item) => currentResourceMenuItem === item.title) as MultiLevelMenuItem,
    [currentResourceMenuItem],
  );

  const handleOpenSidebar = useCallback(() => {
    setOpenSidebar(!openSidebar);
  }, [openSidebar]);

  return (
    <>
      {/*<ReactQueryDevtools initialIsOpen={true} />*/}
      {selectedResourceMenuItem && (
        <>
          <MenuSubMenuPanel
            selectedResourceMenuItem={selectedResourceMenuItem}
            setCurrentResourceMenuItem={setCurrentResourceMenuItem}
          />
          <StyledBackgroundBox onClick={() => setCurrentResourceMenuItem(null)} />
        </>
      )}
      <MenuBaseStyled
        className={clsx(
          {
            'RaSidebar-closed': !openSidebar,
          },
          className,
        )}
        isClosed={!openSidebar}
        {...rest}
      >
        <StyledMenuItemsBox>
          {menuList.map((menuItem) => {
            if ('resource' in menuItem) {
              const props = {
                leftIcon: menuItem.icon,
                onClick: () => setCurrentResourceMenuItem(null),
                primaryText: openSidebar ? menuItem.title : '',
                resource: menuItem.resource,
                to: `/${menuItem.resource}`,
              };

              if (menuItem.counter) {
                return (
                  <MenuItemLinkWithCounter
                    counter={menuItem.counter}
                    key={menuItem.title}
                    {...props}
                  />
                );
              }
              return <MenuItemLink key={menuItem.title} {...props} />;
            }

            return (
              <MenuCollapseItem
                currentResourceMenuItem={currentResourceMenuItem}
                key={menuItem.title}
                multiLevelMenuItem={menuItem}
                setCurrentResourceMenuItem={setCurrentResourceMenuItem}
              />
            );
          })}
        </StyledMenuItemsBox>
        <StyledMenuToggleButtonBox>
          <MenuToggleButton onClick={handleOpenSidebar} />
        </StyledMenuToggleButtonBox>
      </MenuBaseStyled>
    </>
  );
};
